import { emojiCategoryConfigs } from '@src/constants/emojiConfig';
import Picker, { EmojiClickData } from 'emoji-picker-react';
import React from 'react';

type EmojiDropdownMenuPcProps = {
  onEmojiClick: (emojiObject: EmojiClickData) => void;
  position?: {
    x?: number;
    y?: number;
    top?: number;
    maxHeight?: number;
  };
  menuPositionBelow?: boolean;
  horizontalAlign?: 'left' | 'right';
  isInsideModal?: boolean;
};

const EmojiDropdownMenuPc: React.FC<EmojiDropdownMenuPcProps> = ({
  onEmojiClick,
  position,
  menuPositionBelow = true,
  horizontalAlign = 'left',
  isInsideModal = false,
}) => {
  if (!position) {
    return null;
  }
  return (
    <div
      className={isInsideModal ? 'absolute z-50' : 'fixed z-[999999]'}
      style={{
        top: menuPositionBelow ? position.y : undefined,
        bottom: !menuPositionBelow
          ? window.innerHeight - ((position.y ?? 0) + (position.maxHeight ?? 0)) + 5
          : undefined,
        left: horizontalAlign === 'left' ? position.x : undefined,
        right: horizontalAlign === 'right' ? window.innerWidth - (position?.x ?? 0) : undefined,
        maxWidth: '96vw',
        maxHeight: position.maxHeight,
        overflow: 'auto',
      }}
    >
      <div
        className='rounded-md border border-gray-200 bg-white shadow-lg'
        style={{
          width: 'min(360px, 96vw)',
          maxHeight: position.maxHeight,
          overflow: 'auto',
        }}
      >
        <Picker
          open
          onEmojiClick={onEmojiClick}
          skinTonesDisabled
          lazyLoadEmojis
          width='100%'
          searchPlaceholder='絵文字を検索'
          categories={emojiCategoryConfigs}
        />
      </div>
    </div>
  );
};

export default EmojiDropdownMenuPc;
